import * as React from 'react';
import { RefTarget } from '@shared-ui/ref-context';
// Gallery Components
import { SharedUiGalleryWrapper } from 'src/common/components/infosite/shared-ui/details/gallery-wrapper';
export const PropertyGallery = () => React.createElement(RefTarget, {
  name: "Overview"
}, React.createElement(SharedUiGalleryWrapper, null));